import { render, staticRenderFns } from "./transcript-summary-card.vue?vue&type=template&id=216e3806&scoped=true&"
import script from "./transcript-summary-card.vue?vue&type=script&lang=js&"
export * from "./transcript-summary-card.vue?vue&type=script&lang=js&"
import style0 from "./transcript-summary-card.vue?vue&type=style&index=0&id=216e3806&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216e3806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('216e3806')) {
      api.createRecord('216e3806', component.options)
    } else {
      api.reload('216e3806', component.options)
    }
    module.hot.accept("./transcript-summary-card.vue?vue&type=template&id=216e3806&scoped=true&", function () {
      api.rerender('216e3806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/transcript-summary-card/transcript-summary-card.vue"
export default component.exports